interface IDisciplinaryMatter {
    name: string;
    issuingAuthority: string;
}

export const NewDisciplinaryMatter: IDisciplinaryMatter = { name: "", issuingAuthority: "" };

export default IDisciplinaryMatter;
